module.exports = __webpack_public_path__ + "static/media/facebookLogo.ac2bcbbb.svg";